( function( $ ) {

  $(window).on('load', function() {

        $('.front-page-banner').slick({
          // lazyLoad: 'ondemand',
          slidesToScroll: 1,
          autoplay: true,
          fade: true,
          cssEase: 'ease-in-out',
          draggable: false,
          infinite: true,
          arrows: false,
          swipeToSlide: false,
          dots: false
        }).slick("pause");

        var initialDelay = 3000;

        setTimeout(function() {
            $(".front-page-banner").slick("play");
        },initialDelay);

  });


    //Element to apply parralax header scroll reveal effect to
    var ele = document.getElementsByClassName('feature-banner')[0];
    var page = document.querySelector('.home #page');

    //Check if Exists on page
    if(ele) {
      // console.log(true);
      //The reveal effect
      function parallax(ele) {
        var yPos = 0 - window.pageYOffset*1;
        ele.style.top = 0 + yPos + "px";
        // page.style.marginTop = 0 + yPos / 6 + "px";
      }


      // this function runs every time you are scrolling on a page with block
      window.addEventListener("scroll", function(){
          parallax(ele);
      });

    }



} )( jQuery );
